<template>
  <header
    class="header"
    :class="{
      'header--active': !hbgStatus,
      'header--fix-header': isFixedHeader,
    }"
  >
    <div class="pc-language">
      <span
        class="pc-language__text"
        :class="{ 'pc-language__text--active': language === l.lang }"
        v-for="l of languages"
        :key="l.lang"
        @click="handleLanguage(l.lang)"
        >{{ l.label }}</span
      >
    </div>
    <div class="header__content">
      <div class="header__content__logo-function-mobile">
        <!-- <router-link :to="{ name: 'home' }"> -->
        <img class="logo" src="@/assets/img/global/header_logo.svg" @click="toHome" />
        <!-- </router-link> -->

        <div class="function-mobile">
          <img class="function-mobile__language" src="@/assets/icon/icon_website.svg" />
          <img class="function-mobile__member" src="@/assets/icon/icon_member.svg" @click="toMemberInfo" />
          <div class="function-mobile__menu-control" @click="handleHbg">
            <div class="hbg hbg--open" :class="{ 'hbg--active': hbgStatus }"></div>
            <div class="hbg hbg--close1" :class="{ 'hbg--active': !hbgStatus }"></div>
            <div class="hbg hbg--close2" :class="{ 'hbg--active': !hbgStatus }"></div>
          </div>
        </div>
      </div>

      <!-- <Transition name="slide-fade"> -->
      <div
        class="header__content__menu"
        :class="{ 'header__content__menu--visible': !hbgStatus }"
        v-click-away="() => handleCurrExpand('')"
      >
        <!-- <n-collapse-transition :show="!hbgStatus"> -->
        <div class="menu-list-wrap">
          <ul
            class="menu-list"
            :class="{ 'menu-list--active': main.name === currExpand }"
            v-for="main of siteMapConfig"
            :key="main.label"
          >
            <li class="menu-list__item">
              <div class="menu-list__item__box" @click="handleCurrExpand(main.name)">
                <span class="menu-list__item__box__label">
                  {{ main.label }}
                </span>
                <img class="menu-list__item__box__down-icon" src="@/assets/icon/icon_arrow_down_yellow.svg" />
                <img class="menu-list__item__box__pc-icon" :src="menuIconMapping[main.name]" />
                <img class="menu-list__item__box__icon" src="@/assets/icon/icon_arrow_down_brown.svg" />
              </div>
              <!-- <Transition name="slide-fade-second" > -->
              <n-collapse-transition :show="main.name === currExpand">
                <!-- v-show="main.name === currExpand" -->
                <ul class="sub-menu-list" v-show="main.name === currExpand">
                  <li class="sub-menu-list__item" v-for="sub of main.subList" :key="sub.label">
                    <div class="sub-item-box" @click="handleMenu(sub.route.name, sub.route)">
                      <span
                        class="sub-item-box__label"
                        :class="{ 'sub-item-box__label--active': sub.route.name === route.name }"
                      >
                        {{ sub.label }}
                      </span>
                      <img
                        class="sub-item-box__arrow"
                        :class="{ 'sub-item-box__arrow--active': healthEducationExpandStatus }"
                        v-if="sub.route.name === 'health-education'"
                        src="@/assets/icon/icon_arrow_right_brown.svg"
                      />
                    </div>

                    <!-- 第二層 -->
                    {{ sub.route.subListChildren }}
                    <n-collapse-transition :show="sub.subListChildren && healthEducationExpandStatus">
                      <div class="sub-menu-child-list-wrap" v-show="sub.subListChildren && healthEducationExpandStatus">
                        <ul class="sub-menu-child-list">
                          <li
                            class="sub-menu-child-list__item"
                            v-for="subChildren of sub.subListChildren"
                            :key="subChildren.label"
                          >
                            <div @click="handleMenu(subChildren.route.name, subChildren.route)">
                              <span
                                class="sub-menu-child-list__item__label"
                                :class="{
                                  'sub-menu-child-list__item__label--active': subChildren.route.name === route.name,
                                }"
                              >
                                {{ subChildren.label }}
                              </span>
                            </div>
                          </li>
                        </ul>
                        <!-- <img class="sub-menu-child-arrow" src="@/assets/icon/icon_arrow_right_brown.svg" /> -->
                      </div>
                    </n-collapse-transition>
                  </li>
                </ul>
              </n-collapse-transition>
              <!-- </Transition> -->
            </li>
          </ul>
          <div class="logout-row" @click="handleLogout" v-if="isLogin">
            <p class="logout-row__text">登出</p>
          </div>
        </div>
        <!-- </n-collapse-transition> -->
      </div>
      <!-- </Transition> -->
      <div class="function-pc">
        <img class="function-mobile__member" src="@/assets/icon/icon_member.svg" @click="handleAction" />
        <pr-button width="auto" @click="handleAction">{{ isLogin ? '會員專區' : '會員專區/登入' }}</pr-button>
        <span class="logout" @click="handleLogout" v-show="isLogin">登出</span>
      </div>
    </div>
    <img class="header__arc" src="@/assets/img/landing/header_bg.svg" />
  </header>
</template>
<script>
import { defineComponent, ref, onMounted, computed } from 'vue';
import { NCollapseTransition } from 'naive-ui';
import { useRoute, useRouter } from 'vue-router';
import { debounce, throttle } from 'lodash-es';
import { siteMapConfig } from '@/config/routeMappingConfig';
import PrButton from '@/components/Global/PrButton.vue';
import foundationIcon from '@/assets/img/index/header_magnifier.png';
import servicesIcon from '@/assets/img/index/header_heart.png';
import newsIcon from '@/assets/img/index/header_news.png';
import resourcesIcon from '@/assets/img/index/header_feet.png';
import societyIcon from '@/assets/img/index/header_book.png';
import donateIcon from '@/assets/img/index/header_donate.png';
import { useSiteStore } from '@/store/site';
// import useClickaway from '@/hooks/useClickaway';

export default defineComponent({
  name: 'Header',
  components: {
    NCollapseTransition,
    PrButton,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isFixedHeader = ref(false);
    const language = ref('zhTw');
    const hbgStatus = ref(true);
    const healthEducationExpandStatus = ref(false);
    const currExpand = ref('');
    const windowWidth = ref(0);
    const siteStore = useSiteStore();
    const appRoot = computed(() => siteStore.appRoot);
    // const menuRef = ref(null);

    const languages = [
      {
        label: '繁中',
        lang: 'zhTw',
      },
      {
        label: 'ENGLISH',
        lang: 'en',
      },
    ];

    const menuIconMapping = {
      foundation: foundationIcon,
      services: servicesIcon,
      news: newsIcon,
      resources: resourcesIcon,
      society: societyIcon,
      donate: donateIcon,
    };

    const handleLanguage = (lang) => {
      language.value = lang;
    };

    const handleHealthEducationExpand = () => {
      healthEducationExpandStatus.value = !healthEducationExpandStatus.value;
    };

    const handleHbg = () => {
      hbgStatus.value = !hbgStatus.value;
    };

    const handleCurrExpand = (key) => {
      if (currExpand.value === key) {
        currExpand.value = '';
        return;
      }
      currExpand.value = key;
      healthEducationExpandStatus.value = false;
    };

    const handleMenu = (name, routeInfo) => {
      if (name === 'health-education') {
        handleHealthEducationExpand();

        return;
      }
      router.push(routeInfo);
      handleCurrExpand('');

      if (windowWidth.value < 1440) {
        handleHbg();
      }
    };

    const handleAction = () => {
      if (siteStore.isLogin) {
        router.push({ name: 'member-info' });
        return;
      }

      router.push({ name: 'login' });
    };

    const setHbgStatus = () => {
      windowWidth.value = document.body.clientWidth;

      if (windowWidth.value >= 1440) {
        hbgStatus.value = false;
      } else {
        hbgStatus.value = true;
      }
    };
    const setHbgStatusDebounce = debounce(setHbgStatus, 100);

    const showFixedHeader = throttle(() => {
      const yOffset = appRoot.value.scrollTop;

      if (yOffset > 100) {
        isFixedHeader.value = true;
      } else {
        isFixedHeader.value = false;
      }
    }, 100);

    const toMemberInfo = () => {
      if (!siteStore.isLogin) {
        router.push({ name: 'login' });
        return;
      }

      router.push({ name: 'member-info' });
    };

    const handleLogout = () => {
      siteStore.handleLogout();
      router.push({ name: 'home' });
      hbgStatus.value = true;
    };

    const toHome = () => {
      router.push({
        name: 'home',
      });
    };

    appRoot.value.addEventListener('scroll', showFixedHeader);

    onMounted(() => {
      setHbgStatus();
      window.addEventListener('resize', setHbgStatusDebounce);
    });

    return {
      hbgStatus,
      handleHbg,
      siteMapConfig,
      currExpand,
      handleCurrExpand,
      languages,
      language,
      handleLanguage,
      healthEducationExpandStatus,
      route,
      menuIconMapping,
      handleMenu,
      handleAction,
      isFixedHeader,
      toMemberInfo,
      isLogin: computed(() => siteStore.isLogin),
      handleLogout,
      toHome,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  width: 100%;
  // background-color: $c-white;

  &--active {
    height: 100%;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 100%;
    background-color: $c-white;
    position: relative;
    // box-shadow: 6px 6px 3px rgba($c-black, 0.05);

    &__logo-function-mobile {
      @include flex(space-between);
      flex: none;
      width: 100%;
      @include padding(15px 20px);
      height: 85px;
      position: relative;
      z-index: 10;
      background-color: $c-white;
    }

    &__menu {
      width: 100%;
      background-color: $c-white;
      height: 100%;
      // height: calc(100vh - 85px);
      // height: calc(var(--vh, 1vh) * 100 - 85px);
      overflow-y: hidden;
      transition: 0.3s;
      position: absolute;
      top: -100%;
      left: 0;
      // transform: translateY(-200%);
      z-index: 5;

      &--visible {
        top: 85px;
        height: calc(100vh - 85px);
        height: calc(var(--vh, 1vh) * 100 - 85px);
        overflow: auto;
        // transform: translateY(0);
      }
    }
  }

  &__arc {
    display: none;
  }
}

.function-mobile {
  @include flex();
  margin-left: 10px;
  cursor: pointer;

  &__language {
    width: 23px;
  }

  &__member {
    width: 38px;
    margin: 0 20px;
    cursor: pointer;
  }

  &__menu-control {
    width: 28px;
    height: 28px;
    position: relative;
    cursor: pointer;
  }
}

.hbg {
  @include position(center);
  transition: 0.6s;
  opacity: 0;

  &--open {
    width: 100%;
    height: 2px;
    background-color: $c-main;

    box-shadow: 0 8px 0 #805a35, 0 -8px 0 #805a35;
  }

  &--close1 {
    width: 100%;
    height: 2px;
    background-color: $c-main;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &--close2 {
    width: 100%;
    height: 2px;
    background-color: $c-main;
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &--active {
    opacity: 1;
  }
}

.logo {
  width: 168px;
  vertical-align: bottom;
  position: relative;
  top: 2px;
}

.menu-list {
  padding: 18px 0;
  // background-color: $c-white;

  & + & {
    border-top: 1px rgba(grey, 0.2) solid;
  }

  &--active {
    .menu-list__item__box {
      &__label {
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          background-color: $c-main-yellow;
          height: 5px;
          width: 100%;
          @include position(bl, -20px, 0);
        }
      }

      &__icon {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  &__item {
    &__box {
      text-align: center;
      position: relative;

      cursor: pointer;

      &__down-icon {
        display: none;
      }

      &__label {
        @include font-style($c-main, $f-menu-text, 500, 1.6px, 28px);
      }

      &__pc-icon {
        display: none;
      }

      &__icon {
        @include position(tr, 50%, 20px);
        transform: translateY(-50%);
        transition: 0.4s;
      }
    }
  }
}

.sub-menu-list {
  position: relative;
  z-index: 10;
  margin-top: 36px;

  &__item {
    text-align: center;
    cursor: pointer;

    & + & {
      margin-top: 16px;
    }
  }
}

.sub-item-box {
  text-align: center;
  // display: none;
  position: relative;

  &__label {
    @include font-style($c-main-brown, $f-menu-text, 400, 2.6px, 24px);

    &--active {
      opacity: 0.5;
    }
  }

  &__arrow {
    /* display: none; */
    @include position(tr, 50%, 25px);
    transform: translateY(-50%) rotate(90deg);

    &--active {
      transform: translateY(-50%) rotate(270deg);
    }
  }
}

.sub-menu-child-list {
  margin-top: 10px;

  &__item {
    & + & {
      margin-top: 10px;
    }

    &__label {
      @include font-style($c-assist-light-brown, $f-menu-text, 400, 2.6px, 24px);

      &--active {
        opacity: 0.5;
      }
    }
  }
}

.logout-row {
  @include padding(18px 0);
  @include flex(center);
  border-top: 1px solid rgba($c-main-brown, 0.15);
  cursor: pointer;

  &__text {
    @include font-style($c-main, $f-menu-text, 500, 1.6px, 28px);
  }
}

/* .sub-menu-child-arrow {
  @include position(tr, 50%, 10px);
  transform: translateY(-50%);
} */

.pc-language {
  display: none;
}

.function-pc {
  display: none;
}

.logout {
  display: none;
}

// slide-fade
.slide-fade-enter-active {
  transition: all 1s ease-out;
  top: 0;
  left: 0;
}

.slide-fade-leave-active {
  transition: all 1s ease-out;
  top: 0;
  left: 0;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  // transform: translateY(-200%);
  top: -200%;
  left: 0;
  opacity: 0;
}

@media screen and (min-width: $sm-pc) {
  .logo {
    width: 210px;
    top: -10px;
  }

  .header {
    // 滾動後覆蓋原樣式

    &__content {
      @include flex();
      box-shadow: 0 0 0 transparent;
    }
    &.header--fix-header {
      box-shadow: 0px 3px 10px #0000001a;

      &__content {
        // @include flex();
        box-shadow: 0px 3px 10px transparent;
      }

      .pc-language {
        display: none;
      }

      .menu-list__item__box__pc-icon {
        display: none;
      }

      .header__arc {
        display: none;
      }

      .header__content {
        @include flex();
        padding-bottom: 0;
      }

      .menu-list {
        padding: 0;

        &:first-child {
          .menu-list__item__box {
            position: relative;

            &::before {
              content: '';
              background-image: url('~@/assets/img/index/header_line_2.png');
              background-size: 4px 41px;
              width: 4px;
              height: 41px;
              display: inline-block;
              @include position(tl, 50%, 0);
              transform: translateY(-50%);
            }
          }
        }

        .menu-list__item__box {
          position: relative;

          &::after {
            content: '';
            background-image: url('~@/assets/img/index/header_line_2.png');
            background-size: 4px 41px;
            width: 4px;
            height: 41px;
            display: inline-block;
            @include position(tr, 50%, 0);
            transform: translateY(-50%);
          }
        }
      }

      .menu-list__item__box {
        @include flex(center);
      }

      .menu-list__item__box__label {
        width: auto;
      }

      .menu-list__item__box__down-icon {
        display: inline-block;
        margin-left: 5px;
      }

      .sub-menu-list {
        top: calc(100% + 20px);
      }

      .logo {
        width: 150px;
      }
    }

    &--active {
      height: auto;
    }

    &__content {
      flex-direction: row;
      height: auto;
      box-sizing: border-box;
      padding: 0 60px 0px;

      &__logo-function-mobile {
        width: auto;
        padding: 0;

        align-items: center;
      }

      &__menu {
        position: static;
        @include padding(0 10px);
        height: auto;
        overflow: visible;

        .menu-list {
          padding: 0;

          &:first-child {
            .menu-list__item__box {
              position: relative;

              &::before {
                content: '';
                background-image: url('~@/assets/img/index/header_line.png');
                background-size: 5px 63px;
                width: 5px;
                height: 63px;
                display: inline-block;
                @include position(tl, 50%, 0);
                transform: translateY(-50%);
              }
            }
          }
        }
      }
    }

    &__arc {
      width: 100%;
      position: relative;
      top: -1px;
      z-index: -1;
      display: block;
    }
  }

  .function-mobile {
    display: none;

    &__member {
      cursor: pointer;
      margin-left: 0;
    }
  }

  .function-pc {
    @include flex();
  }

  .menu-list-wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .menu-list {
    & + & {
      border-top: 0;
    }

    &--active {
      .menu-list__item__box {
        &__label {
          position: relative;

          &::before {
            display: none;
          }
        }
      }

      .sub-menu-list {
        margin-top: 4px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    & + & {
    }

    &__item {
      // width: 145px;
      position: relative;

      &__box {
        @include padding(0 25px);
        @include flex(flex-start, center, column);
        position: relative;

        &::after {
          content: '';
          background-image: url('~@/assets/img/index/header_line.png');
          background-size: 5px 63px;
          width: 5px;
          height: 63px;
          display: inline-block;
          @include position(tr, 50%, 0);
          transform: translateY(-50%);
        }

        &__label {
          display: inline-block;
          width: 100%;
          white-space: nowrap;

          &::before {
            display: none;
          }
        }

        &__pc-icon {
          margin-top: 8px;
          display: inline-block;
          width: 54px;
        }

        &__icon {
          display: none;
        }
      }
    }
  }

  .sub-menu-list {
    // box-shadow: 6px 6px 3px rgba($c-black, 0.05);
    // border-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    box-shadow: 6px 6px 3px rgb(0 0 0 / 5%);

    width: auto;
    background-color: $c-white;
    margin-top: 4px;
    padding: 10px;
    @include position(tl, 100%, 0);

    &__item {
      white-space: nowrap;
      position: relative;
      height: 60px;
      @include padding(0 40px);
      @include flex();

      & + & {
        margin-top: 0;
        border-top: 1px solid rgba($c-main-brown, 0.15);
      }
    }
  }

  .sub-item-box {
    @include flex();
    text-align: center;

    &__label {
      display: inline-block;
    }

    &__arrow {
      display: inline-block;
      margin-left: 8px;
      margin-top: 0;
      transform: rotate(0deg);
      position: static;
      width: 7px;
    }
  }

  .sub-menu-child-list-wrap {
    @include position(tl, 0, calc(100% + 10px));
  }

  .sub-menu-child-list {
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    box-shadow: 6px 6px 3px rgb(0 0 0 / 5%);

    width: 100%;
    background-color: $c-white;
    @include padding(0px 8px 0px);
    margin-top: 0;

    &__item {
      white-space: nowrap;
      @include flex();
      @include padding(0 40px);

      height: 60px;

      & + & {
        margin-top: 0;
        border-top: 1px solid rgba($c-main-brown, 0.15);
      }

      &__label {
        display: inline-block;

        @include font-style($c-main-brown, $f-menu-text, 400, 2.6px, 24px);

        &--active {
          opacity: 0.5;
        }
      }
    }
  }

  .pc-language {
    @include flex(flex-end, flex-start);
    background-color: $c-white;
    padding-right: 60px;

    &__text {
      @include font-style(rgba($c-main, 0.5), $f-menu-text, 400, 1.6px, 36px);
      cursor: pointer;

      &--active {
        opacity: 1;
      }

      & + & {
        margin-left: 18px;
      }
    }
  }

  .logout {
    display: inline-block;
    width: 40px;
    @include font-style($c-main, $f-menu-text, 400, 1.6px, 28px);
    margin-left: 18px;
    cursor: pointer;
    text-align: right;
  }

  .logout-row {
    display: none;
  }
}

@media screen and (min-width: $pc) {
  .logo {
    width: 265px;
  }

  .menu-list {
    &__item {
      &__box {
        @include padding(0 30px);
      }

      // item
      // @include padding(0 5px);
      // width: 150px;
    }
  }
}

@media screen and (min-width: $extra-pc) {
  .menu-list {
    &__item {
      // @include padding(0 5px);
      // width: 168px;

      &__box {
        @include padding(0 40px);
      }
    }
  }
}
</style>
